import React, { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import { CheckInContext } from "../../context/checkin";
import { UserContext } from "../../context/user";
import { getCDNImage } from "../../globals";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Building } from "../../components/Icons";
import { invertDate, formatDate, formatDayMonth, roomData, reservationDisplayCode } from "../../functions";
import { T } from "react-translator-component";
import processHtml from "../../components/processHtml";

export default function CheckInHeaderSimple({ variant = "long" }) {
  const { data: checkIn, } = useContext(CheckInContext);
  const { language } = useContext(UserContext);

  const room = roomData(checkIn, language);
  console.log('12feb room', room);

  return (<Row className={`text-left mx-1 ${variant !== "small" ? "mb-1" : ""}`}>
    <Col xs={12}>
      <div className="d-flex justify-content-between align-items-center" style={{ gap: 5, minWidth: 0 }}>
        <div>
          <p className="general-text-sm text-center mt-1 mb-0">
            <span>{T("checkin.reservation-code")}</span>
            {`: `}
            <span className="font-weight-bold">{reservationDisplayCode(checkIn)}</span>
          </p>
        </div>
        <div className="pl-1" style={{ minWidth: 120, maxWidth: 120, borderLeft: "1px solid #EEE" }} >
          <p className="d-flex justify-content-center align-items-center general-text-sm text-center mt-1 mb-0">
            <FontAwesomeIcon
              icon={faCalendarAlt}
              className="text-muted"
              style={{ fontSize: "20px", margin: "5px" }}
            />{" "}
            <div className="px-1 text-center">
              {formatDayMonth(checkIn.reservation.arrival, T("general.short-dateformat"))}
              {` / `}
              {formatDayMonth(checkIn.reservation.departure, T("general.short-dateformat"))}
            </div>
          </p>
        </div>
      </div>
    </Col>
  </Row>);
}